import { useContext, ref, readonly } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
function useAttributeCollectionItems() {
  const loading = ref(false);
  const error = ref({
    getItems: null
  });
  const { app } = useContext();
  const getItems = async (params) => {
    var _a;
    Logger.debug(`useAttributeCollection/getCollection`);
    let items = null;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.attributeCollectionItems(params);
      items = ((_a = data.WmAttributeCollectionItems) == null ? void 0 : _a.items) || null;
    } catch (err) {
      error.value.getItems = err;
      Logger.error(`useAttributeCollectionItems/getItems`, err);
    } finally {
      loading.value = false;
    }
    return items;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    getItems
  };
}
export {
  useAttributeCollectionItems
};
